import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  heading: FelaCSS;
  subheading: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginTop: spacing[20],
    height: 371,
    paddingLeft: spacing[16],
    justifyContent: 'center',
    borderRadius: 16,
    background: `url(https://media.bridebook.com/assets/seo-pages/signup-cover.jpg) 0px -707.188px / 100% 416.543% no-repeat`,
    alignItems: 'flex-start',

    maxWidthTabletSm: {
      height: 430,
      marginTop: spacing[6],
      padding: spacing[4],
      justifyContent: 'flex-end',
      background: `url(https://media.bridebook.com/assets/seo-pages/signup-cover.jpg) -15.909px -277.088px / 138.261% 166.436% no-repeat`,
    },
  },

  heading: {
    marginTop: '0',
    marginBottom: 2,
    fontDefaultSemiBold: 32,
    lineHeight: '48px',
    color: colors.white,
  },

  subheading: {
    marginTop: '0',
    marginBottom: 6,
    fontDefault: 18,
    lineHeight: '150%',
    color: colors.white,
  },
});

export default styles;
